module.exports = __webpack_public_path__ + "img/buzz-icon-yellow.957fea85.svg";